import { useEffect, useState, useCallback } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import PageWrapper from '../../layout/PageWrapper';
import Nav from '../../components/Nav';
import { useAuth } from '../../components/Authentication/AuthProvider';
import NewNotification from '../../components/NewNotification';
import Spinner from '../../components/Spinner';
import HeaderBar from '../../components/HeaderBar';
import Modal from '../../components/Modal';
import { getPushNotificationLogs } from '../../api/pushNotificationsAPI';
import { COLORS } from '../../utils/constants/colors';

const Notifications = () => {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { token } = useAuth();

  const handleGetLogs = useCallback(async () => {
    setIsLoading(true);
    const data = await getPushNotificationLogs(token);
    setLogs(Array.isArray(data) ? data : []);
    setIsLoading(false);
  }, [token]);

  useEffect(() => {
    handleGetLogs();
  }, [handleGetLogs]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleNotificationSent = () => {
    handleCloseModal();
    handleGetLogs();
  };

  const columns = [
    { field: 'id', headerName: 'ID', minWidth: 60, maxWidth: 60 },
    { field: 'title', headerName: 'Title', minWidth: 160, flex: 1 },
    {
      field: 'body',
      headerName: 'Message',
      minWidth: 200,
      flex: 2,
      renderCell: (params) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {params.value}
        </span>
      ),
    },
    { field: 'audience', headerName: 'Audience', minWidth: 100, maxWidth: 120 },
    { field: 'recipientCount', headerName: 'Recipients', minWidth: 100, maxWidth: 120 },
    {
      field: 'successCount',
      headerName: 'Delivered',
      minWidth: 100,
      maxWidth: 120,
      renderCell: (params) => (
        <span style={{ color: COLORS.greenRGBA, fontWeight: 'bold' }}>{params.value}</span>
      ),
    },
    {
      field: 'failureCount',
      headerName: 'Failed',
      minWidth: 80,
      maxWidth: 100,
      renderCell: (params) => (
        <span style={{ color: params.value > 0 ? COLORS.red : COLORS.darkGray }}>
          {params.value}
        </span>
      ),
    },
    { field: 'createdAt', headerName: 'Sent at', minWidth: 180 },
    { field: 'adminEmail', headerName: 'Sent by', minWidth: 200, flex: 1 },
  ];

  return (
    <>
      <Nav />
      <PageWrapper>
        <HeaderBar title="Notifications" onOpenModal={handleOpenModal} />
        <div style={{ height: '70vh', width: '100%' }}>
          <DataGrid
            rows={logs}
            columns={columns}
            disableSelectionOnClick
            sx={{ color: `${COLORS.darkGray}` }}
          />
        </div>
      </PageWrapper>
      {isLoading && <Spinner />}
      <Modal
        title="New notification"
        isModalOpen={isModalOpen}
        onCloseModal={handleCloseModal}
        noFooter
        width="36rem"
      >
        <NewNotification onNotificationSent={handleNotificationSent} />
      </Modal>
    </>
  );
};

export default Notifications;
